import React, { createContext, useCallback, useContext, useMemo, useState } from "react";
import dataEN from "../locales/en/translation.json";
import dataFR from "../locales/fr/translation.json";
import dataRU from "../locales/ru/translation.json";

const STORAGE_KEY = "language";
const TRANSLATIONS = { EN: dataEN, FR: dataFR, RU: dataRU };

function loadInitialLanguage() {
  const stored = localStorage.getItem(STORAGE_KEY);
  return TRANSLATIONS[stored] ? stored : "EN";
}

const LanguageContext = createContext(null);

export function LanguageProvider({ children }) {
  const [language, setLanguageState] = useState(loadInitialLanguage);

  const setLanguage = useCallback((next) => {
    if (!TRANSLATIONS[next]) return;
    localStorage.setItem(STORAGE_KEY, next);
    setLanguageState(next);
  }, []);

  const value = useMemo(
    () => ({ language, data: TRANSLATIONS[language], setLanguage }),
    [language, setLanguage]
  );

  return (
    <LanguageContext.Provider value={value}>{children}</LanguageContext.Provider>
  );
}

export function useLanguage() {
  const ctx = useContext(LanguageContext);
  if (!ctx) throw new Error("useLanguage must be used inside <LanguageProvider>");
  return ctx;
}
